module.exports = __webpack_public_path__ + "img/logo7.68f319d2.png";